<script lang="ts">
  import { untrack } from 'svelte';
  import { page } from '$app/state';
  import { browser } from '$app/environment';

  import { PUBLIC_BRAND_SLUG, PUBLIC_BRAND_NAME } from '$env/static/public';

  import { StoryblokComponent, useStoryblokBridge } from '@storyblok/svelte';

  import { AlternateLinks } from '@agapi/ui/alternate-links';

  import { JsonLd } from '@agapi/ui/json-ld';

  import type { Response } from './';
  import { getLocaleFromUrl } from '../../utils';

  const { data }: { data: Response } = $props();

  let content: any = $state(null);

  const { language } = getLocaleFromUrl(page.url);

  $effect(() => {
    const isPreview = browser && new URLSearchParams(window.location.search).has('_storyblok');
    console.log('isPreview', isPreview);
    if (isPreview) {
      untrack(async () => {
        const { getStoryblokApi } = await import('@storyblok/svelte');
        const storyblokApi = getStoryblokApi();
        console.log('storyblokApi', storyblokApi);
        const story = (
          await storyblokApi.get(`cdn/stories/${PUBLIC_BRAND_SLUG}/${data.pageData.slug}`, {
            version: 'draft',
            language: language
          })
        ).data.story;

        content = story.content;
        useStoryblokBridge(story.id, (newStory) => (content = newStory.content), {
          preventClicks: true
        });
      });
    }
  });

  const schemaData = $derived(() => ({
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: data.pageData?.meta?.title || data.pageData.name,
    description: data.pageData?.meta?.description,
    url: `${page.url.origin}${page.url.pathname}`
  }));
</script>

<svelte:head>
  <title>{data.pageData?.meta?.title || data.pageData.name} - {PUBLIC_BRAND_NAME}</title>
  <meta name="description" content={data.pageData?.meta?.description} />
  <meta name="robots" content={data.pageData?.meta?.robots} />
  <link
    rel="canonical"
    href={data.pageData?.meta?.canonical ?? `${page.url.origin}${page.url.pathname}`}
  />
  <meta property="og:title" content={data.pageData?.meta?.title || data.pageData.name} />
  <meta property="og:description" content={data.pageData?.meta?.description} />
  <meta property="og:url" content={`${page.url.origin}${page.url.pathname}`} />
  <meta property="og:type" content="website" />
  {#if data.pageData?.meta?.image}
    <meta property="og:image" content={data.pageData?.meta?.image} />
  {/if}
  {#if data.pageData?.meta?.canonical}
    <link rel="canonical" href={data.pageData?.meta?.canonical} />
  {/if}
</svelte:head>

<AlternateLinks links={data.pageData.alternates ?? {}} />

<JsonLd data={schemaData} />

{#key page.url.pathname}
  {#if content}
    {#each content?.body || [] as item}
      <StoryblokComponent blok={item} />
    {/each}
  {:else}
    {#each data.pageData?.content || [] as item}
      <StoryblokComponent blok={item} />
    {/each}
  {/if}
{/key}
